import { Controller } from "@hotwired/stimulus";

// "Visa bagagealternativ" / hide again, per traveler. Replaces the old
// jQuery .toggle_extra_baggage_link click handler. Generic enough to
// reuse for any show/hide-behind-a-fold panel, not just baggage --
// chevronTarget is optional (step_2_brand.html.erb's itinerary fold is
// the first caller to use it; every existing caller has no chevron
// target at all and is unaffected).
export default class extends Controller {
  static targets = ["panel", "label", "chevron"];
  static values = {
    showText: String,
    hideText: String
  };

  toggle() {
    const isHidden = this.panelTarget.classList.toggle("hidden");
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = isHidden ? this.showTextValue : this.hideTextValue;
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", !isHidden);
    }
  }
}
